const vipRouter = {
  path: '/svip',
  component: () => import('@/views/new_vip/vipRouter'),
  redirect: '/svip/index',
  name: 'Svip',
  children: [{
    path: 'index',
    name: 'vip',
    component: () => import('@/views/new_vip/index'),
    meta: {
      title: ''
    }
  }, {
    path: 'vipList',
    name: 'vipList',
    component: () => import('@/views/new_vip/vipList'),
    meta: {
      title: ''
    }
  }, {
    path: 'vipSpecial',
    name: 'vipSpecial ',
    component: () => import('@/views/new_vip/vipSpecial'),
    meta: {
      title: ''
    }
  }, {
    path: 'allProjects',
    name: 'allProjects ',
    component: () => import('@/views/new_vip/allProjects'),
    meta: {
      title: ''
    }
  }]
}
export default vipRouter
